// 图片类型
// 书籍推荐（书籍排行）图书销量榜 1
// 周边推荐 (其他品类）2,
// 主推出版社（出版社推荐）3,
// 地方版特色 4,
// 广告位 5,
// 公共馆 6,
// 高校馆 7,
// 多元化产品 8,
// 展会默认主页 9,
// 照片墙 10,
// 书籍销售榜（书籍排行）11,
// 出版社销售榜 出版社销量榜 出版社排行 12,
// 主页默认直播链接 13
const imageTypes = {
    book_suggest: 1, // 书籍推荐（书籍排行）图书销量榜 1
    press: 3, // 主推出版社（出版社推荐）3,
    adv: 5, // 广告位
    photo_wall: 10, // 照片墙
    default_home: 9, // 展会默认主页
    book_rank: 11, // 书籍销售榜（书籍排行）11,
    press_rank: 12, // 出版社销售榜 出版社销量榜 出版社排行 12,
    poster: 14, // 专场海报
    video: 13, // 主页默认直播链接
    default_home_m: 15
}

export {
  imageTypes
}



// WEBPACK FOOTER //
// ./src/common/utils/constant.js